define([
        'text!./templates/mfp-select-leasing-duration.html',
    ],
    templateStr => [
        () => { // NOSONAR
            return {
                restrict: 'E',
                scope: {
                    leasingDuration: '=', //view model!
                },
                template: templateStr,
                controller: [
                    '$scope',
                    ($scope) => {
                        $scope.durations = $scope.leasingDuration.aspects.availableValues;
                        $scope.durationsLoaded = true;

                        $scope.vm = {
                            inputString: $scope.leasingDuration && $scope.leasingDuration.value && $scope.leasingDuration.value.name || '',
                        };
                        const durationFieldsToFilter = [
                            'name',
                        ];

                        $scope.searchDuration = (userInput) => {
                            if (!userInput) {
                                return $scope.durations;
                            }

                            /**
                             * Filter Dealers:
                             * If every given string (splitted at space) matches at least one of the fields in a Dealer
                             * include that Dealer in the list.
                             */
                            return $scope.durations.filter(duration =>
                                userInput.toLowerCase().split(' ').every(lowerCaseInput =>
                                    durationFieldsToFilter.some((durationField) => {
                                        const actField = duration[durationField];
                                        return actField && actField.toLowerCase().includes(lowerCaseInput);
                                    })
                                )
                            );
                        };

                        $scope.onDurationSelected = (duration) => {
                            $scope.vm.inputString = duration.name;
                            $scope.leasingDuration.value = duration;
                        };

                        $scope.unselectDuration = () => {
                            if ($scope.leasingDuration.value) {
                                $scope.leasingDuration.value = undefined;
                            }
                        };
                    },
                ],
            };
        },
    ]
);


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPSelectLeasingDuration.js